class PasswordPage extends HTMLElement {
  constructor() {
    super();

    this.loginFormToggles = this.querySelectorAll('[data-login-form-toggle]');
    this.loginForm = this.querySelector('[data-login-form]');
    this.content = this.querySelector('[data-content]');

    if (this.loginFormToggles.length) {
      this.loginFormToggles.forEach((loginFormToggle) => {
        loginFormToggle.addEventListener('click', this.toggleLoginForm.bind(this));
      });
    }
  }

  toggleLoginForm() {
    this.loginForm.classList.toggle('d-none');
    this.content.classList.toggle('d-none');
  }
}

customElements.define('password-page', PasswordPage);
